import React, { useEffect, useState } from 'react';
import { Box } from 'grommet';
import PageWrapper from '../PageWrapper/PageWrapper';
import PageTitle from '../PageTitle/PageTitle';
import { IPagination, Pagination as PaginationClass } from '@interfaces/IPagination';
import { IUser } from '@interfaces/IUser';
import getUsers from './Helpers/getUsers';
import Loading from '@components/Loading/Loading';
import Pagination from '@components/Pagination/Pagination';
import totalPages from '@utils/totalPages';
import PageSize from '@components/PageSize/PageSize';
import ManageUsersDataTable from './Components/ManageUsersDataTable';

export interface ManageUsersProps {}

const ManageUsers: React.FC<ManageUsersProps> = (): JSX.Element => {
  const [loading, setLoading] = useState<boolean>(true);
  const [users, setUsers] = useState<IPagination<IUser[]>>(new PaginationClass(1, 30, 30));

  const initialPagination: IPagination<IUser[]> = new PaginationClass(1, 30, 30);

  const getData = async (pagination: IPagination = initialPagination): Promise<void> => {
    setLoading(true);

    await getUsers(pagination)
      .then((data): void => {
        if (data.Success) {
          setUsers(data.Object!);
          setLoading(false);
        }
      })
      .catch((): void => {
        setUsers(initialPagination);
      });
  };

  const updatePage = (newPage: string): void => {
    const newPagination = new PaginationClass(parseInt(newPage, 10), users.PageSize);
    getData(newPagination);
  };

  const updatePageSize = (newSize: string): void => {
    const newPagination = new PaginationClass(1, parseInt(newSize, 10));
    getData(newPagination);
  };

  useEffect((): void => {
    getData(initialPagination);
  }, []);

  return (
    <PageWrapper>
      <PageTitle
        Text="Manage Users"
      />
      {
        (loading) ? (<Loading />) : (
          <Box
            fill="horizontal"
            direction="column"
            gap="xsmall"
            margin={{
              top: 'medium',
            }}
          >
            {
              ((users.Total || 0) > (users.PageSize || 0)) && (
                <Pagination
                  Page={users.Page as number}
                  Last={totalPages(users.Total as number, users.PageSize as number)}
                  onChange={updatePage}
                />
              )
            }
            <ManageUsersDataTable
              refreshData={getData}
              users={users.Object!}
            />
            {
              ((users.Total || 0) > (users.PageSize || 0)) && (
                <>
                  <PageSize
                    Size={users?.PageSize as number}
                    onChange={updatePageSize}
                  />
                  <Pagination
                    Page={users.Page as number}
                    Last={totalPages(users.Total as number, users.PageSize as number)}
                    onChange={updatePage}
                  />
                </>
              )
            }
          </Box>
        )
      }
    </PageWrapper>
  );
};

ManageUsers.displayName = 'ManageUsers';

export default ManageUsers;
